import { EventEmitter, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CloudinaryHelper, CloudinaryUrlParser } from '@common/cloudinary/shared';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiInputTextComponent } from '@common/ui/frontend-shared/input-text';
import { AppRequestService, ConfigService, LocalMessageHandlerService } from '@core/frontend-shared';
import { MediaAssetProviderCloudinaryFrontend } from './media-asset-provider';
import { from } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@angular/forms";
export let CloudinarySelectFromHostComponent = /*#__PURE__*/(() => {
  class CloudinarySelectFromHostComponent {
    constructor(api, config, messages) {
      this.api = api;
      this.config = config;
      this.messages = messages;
      this.busy = signal(false, ...(ngDevMode ? [{
        debugName: "busy"
      }] : /* istanbul ignore next */[]));
      this.fileUrl = signal(null, ...(ngDevMode ? [{
        debugName: "fileUrl"
      }] : /* istanbul ignore next */[]));
      this.allowedFileTypes = input('any', ...(ngDevMode ? [{
        debugName: "allowedFileTypes"
      }] : /* istanbul ignore next */[]));
      this.fileSelected = new EventEmitter();
      this.urlParser = new CloudinaryUrlParser(this.config);
    }
    clickNext() {
      this.busy.set(true);
      const fileUrl = this.fileUrl();
      const allowedFileTypes = this.allowedFileTypes();
      try {
        const fileUrlInfo = this.urlParser.parse(fileUrl);
        const fileName = fileUrlInfo.publicId.split('/').pop();
        if (allowedFileTypes !== 'any') {
          const allowedResourceType = CloudinaryHelper.toCloudinaryResourceType(allowedFileTypes);
          if (fileUrlInfo.resourceType !== allowedResourceType) {
            this.messages.createAndDisplay(`Die angegebene Datei ist vom Typ ${fileUrlInfo.resourceType}. Dieses Feld erlaubt nur den Typ ${allowedFileTypes}.`).setSeverity('warn');
            this.busy.set(false);
            return;
          }
        }
        from(this.provider.getAssetDetailsByUrl(fileUrl)).subscribe({
          next: response => {
            this.busy.set(false);
            if (!response?.type) throw new Error('Could not determine type of selected file. Aborting Asset creation');
            this.fileSelected.emit({
              assetData: CloudinaryHelper.mediaAssetDetailsToAssetData(response),
              name: fileName
            });
          },
          error: error => {
            this.busy.set(false);
            console.error(error);
          }
        });
      } catch (error) {
        this.busy.set(false);
        this.messages.createAndDisplay(error);
      }
    }
    static {
      this.ɵfac = function CloudinarySelectFromHostComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CloudinarySelectFromHostComponent)(i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i1.ConfigService), i0.ɵɵdirectiveInject(i1.LocalMessageHandlerService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CloudinarySelectFromHostComponent,
        selectors: [["ng-component"]],
        inputs: {
          allowedFileTypes: [1, "allowedFileTypes"],
          provider: "provider"
        },
        outputs: {
          fileSelected: "fileSelected"
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 6,
        vars: 2,
        consts: [[1, "ui-margin", 3, "ngModelChange", "ngModel"], [1, "ui-text-center"], ["uiButton", "", "label", "best\u00E4tigen", 3, "click", "loading"]],
        template: function CloudinarySelectFromHostComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1, "URL der Cloudinary Datei hier einf\u00FCgen:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "ui-input-text", 0);
            i0.ɵɵlistener("ngModelChange", function CloudinarySelectFromHostComponent_Template_ui_input_text_ngModelChange_2_listener($event) {
              return ctx.fileUrl.set($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "app-messages");
            i0.ɵɵelementStart(4, "div", 1)(5, "button", 2);
            i0.ɵɵlistener("click", function CloudinarySelectFromHostComponent_Template_button_click_5_listener() {
              return ctx.clickNext();
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.fileUrl());
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("loading", ctx.busy());
          }
        },
        dependencies: [FormsModule, i2.NgControlStatus, i2.NgModel, UiInputTextComponent, UiButtonComponent, AppMessagesComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CloudinarySelectFromHostComponent;
})();